/**
 * Base URL de l'API — injectée au build (Vite) via VITE_API_URL.
 *
 * En dev, VITE_API_URL n'est pas défini : vite.config.ts proxy les chemins
 * relatifs (/auth, /world, /chat, /media, /integration, /admin, /assets)
 * vers localhost:3000, donc le fallback ne sert qu'en dev.
 *
 * En prod, le front (demo.app.lumetic.fr) et l'API (api.lumetic.fr) sont
 * sur des domaines différents et il n'y a PAS de reverse-proxy côté nginx
 * du web — tout fetch vers l'API DOIT donc utiliser API_BASE.
 */
export const API_BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

/**
 * Transforme un chemin d'asset relatif renvoyé par l'API (ex: "/assets/tenants/{id}/maps/lobby/map.tmj")
 * en URL absolue (API_BASE) — en prod, front et API sont sur des domaines différents.
 * L'authentification se fait séparément via header Authorization (voir authXhrSettings
 * dans game/loaders/ZoneLoader.ts pour le loader Phaser, qui ne peut pas suivre les
 * redirections de fetch() classiques mais supporte xhrSettings.headers).
 */
export function assetUrl(path: string): string {
  return `${API_BASE}${path}`;
}
